import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapState } from 'vuex';
import service from '../services/service';
import ICountUp from 'vue-countup-v2';
import cookie from '@tencent/vft-common/cookie';
export default {
  name: 'eggInfo',
  components: {
    ICountUp: ICountUp
  },
  props: ['money'],
  data: function data() {
    return {
      fetch: false,
      countUp: null,
      vuid: ''
    };
  },
  computed: _objectSpread({}, mapState(['isLogin']), mapGetters(['eggInfo', 'payVip', 'egg']), {
    eggCount: function eggCount() {
      return this.eggInfo && this.eggInfo.egg_count || 0;
    },
    isYoo: function isYoo() {
      var _this = this;

      return [1, 3].some(function (item) {
        return item === _this.eggInfo['egg_type'];
      });
    },
    isLv7: function isLv7() {
      return this.payVip && this.payVip.vip && this.payVip.level === 7;
    },
    isVip: function isVip() {
      return this.payVip && this.payVip.vip && this.payVip.level !== 7;
    },
    notVip: function notVip() {
      return !this.payVip || !this.payVip.vip;
    },
    text: function text() {
      var _this2 = this;

      if (!this.isLogin) {
        return this.setting.无登录;
      }

      if ([2, 3].some(function (item) {
        return item === _this2.eggInfo['egg_type'];
      })) {
        return this.setting.小捣蛋;
      }

      if (this.isLv7) {
        return this.setting.v7;
      }

      if (this.isVip) {
        return this.setting.会员;
      }

      return this.setting.非会员;
    },
    eggTypeList: function eggTypeList() {
      return window.setting.蛋类型;
    }
  }),
  watch: {
    eggCount: function eggCount(v) {
      if (this.countUp) {
        this.countUp.update(v);
      }
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.$watch('eggInfo', function () {
                window.bodymovin.loadAnimation({
                  path: process.env.NODE_ENV === 'development' ? '/ribbonLottie/data.json' : '//vm.gtimg.cn/tencentvideo/script/film/v3/d2d/ribbonLottie/data.json',
                  //json文件路径
                  loop: false,
                  autoplay: true,
                  renderer: 'svg',
                  //渲染方式，有"html"、"canvas"和"svg"三种
                  container: document.getElementById('lottieBox')
                });
              });
              this.vuid = cookie.get('vuserid');

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    onReady: function onReady(instance) {
      this.countUp = instance;
    },
    addEgg: function addEgg() {
      window.location.hash = 'mod_jackpot';
      setTimeout(function () {
        window.location.hash = '0';
      }, 1000);
    }
  },
  settingKey: '蛋详情',
  setting: {
    无登录: '登录后查看福蛋',
    非会员: '每天送你2个新春福蛋，速去碰碰碰钱呀！',
    会员: '亲爱的VIP，每天送你4个新春福蛋，祝你碰出钱多多！',
    v7: '这位V7朋友，每天送你6个新春福蛋，快去和好友碰现金大奖！',
    小捣蛋: '蛋选之人！恭喜你获得隐藏小捣蛋！好友碰出的奖品也归你！'
  }
};